import React from "react";
import Home from "./Home";
const Index = () => <Home />;
export default Index;
